import React from "react";

function ArrowDownSvg({ color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "14"}
      height={props.width || "8"}
      fill="none"
      viewBox={props.viewBox || "0 0 14 8"}
      className={props.className}
    >
      <path
        stroke={color || "#002247"}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.5 9L12.5 15L18.5 9"
        strokeWidth="1.5"

      ></path>
    </svg>
  );
}

export default ArrowDownSvg;
